import React, { Component } from "react";
import CommonBreadCrumb from "../breadCrumbs";
import NfoRouter from "./nfoRoutes";

export const NFO_URL = `/nfo`;

// const breadcrumbNameMap = {
//   "/nfo":{
//     title: "NFO Funds",
//     to: NFO_URL + `/nfo-funds`,
//   },
//   "/nfo-funds": {
//     title: "NFO Funds",
//     to: NFO_URL + `/nfo-funds`,
//   },
//   "/nfo-funds/nfo-transact": {
//     title: "NFO Fund Transact",
//     to: NFO_URL + `/nfo-funds/nfo-transact`,
//   },

// };

export default class NFOComponent extends Component {
  render() {
    const { location } = this.props;
    // const pathnames =
    // location.pathname.includes("/details")
    // ? location.pathname
    //     .split("/")
    //     .filter(name => name)
    //     .slice(0, 2)
    // : location.pathname.split("/").filter(name => name);
    return (
      <div>
        {/* <CommonBreadCrumb
          hideFirst={true}
          pathnames={pathnames}
          breadcrumbNameMap={breadcrumbNameMap}
        /> */}
        <NfoRouter
          history={this.props.history}
          location={this.props.location}
        />
      </div>
    );
  }
}
